import { LoginStateModule } from '@/store/modules/LoginStateModule'
import { LoginUser } from '@/domain/LoginUser';

/**
 * メニュー項目管理サービス
 */
export default class MenusService {
    /** インスタンス */
    private static _instance: MenusService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new MenusService();
        }
        return this._instance;
    }

    /**
     * ナビゲーションメニュー表示
     */
    public drawer = false;

    /** 権限 */
    private AUTH_EVERYONE = "everyone"
    private AUTH_ADMIN = "admin"
    private AUTH_LOGIN = "login"
    private AUTH_LOGOUT = "logout"

    /** メニューバー */
    private allMenus = [
        { title: "見積", icon: "mdi-page-previous-outline", items: [
            { title: "見積作成", to: "/member/estimate/new", authoritiy: "tool.estimate.new"},
            { title: "見積一覧", to: "/member/estimate/list", authoritiy: "tool.estimate.list"},
        ]},
        { title: "依頼受付", icon: "mdi-page-next-outline", items: [
            { title: "検査依頼受付", to: "/member/request/new", authoritiy: "tool.request.new"},
            { title: "検査依頼一覧", to: "/member/request/list", authoritiy: "tool.request.list"},
            { title: "検査依頼CSV登録", to: "/member/request/csv", authoritiy: "tool.request.csv"},
            { title: "検査依頼受付CSV変換", to: "/member/request/csv_convert", authoritiy: "tool.request.csv_convert"},
            { title: "受付番号検索", to: "", authoritiy: "tool.request.search"},
        ]},
        { title: "請書", icon: "mdi-page-previous", items: [
            { title: "請書一覧", to: "/member/confirmation/list", authoritiy: "tool.confirmation.list"},
        ]},
        { title: "検査", icon: "mdi-flask", items: [
            { title: "未検査一覧", to: "/member/uninspected/list", authoritiy: "tool.uninspected.list"},
            { title: "検査一覧", to: "/member/inspection/list", authoritiy: "tool.inspection.list"},
        ]},
        { title: "報告", icon: "mdi-text-box-check", items: [
            { title: "未報告一覧", to: "/member/unreported/list", authoritiy: "tool.unreported.list"},
            { title: "報告書一覧", to: "/member/report/list", authoritiy: "tool.report.list"},
            { title: "報告CSVエクスポート", to: "/member/report/csv_export", authoritiy: "tool.report.csv_export"},
            { title: "報告CSVインポート", to: "/member/report/csv_import", authoritiy: "tool.report.csv_import"},
        ]},
        { title: "請求", icon: "mdi-cash-usd", items: [
            { title: "未請求一覧", to: "/member/unclaimed/list", authoritiy: "tool.unclaimed.list"},
            { title: "請求一覧", to: "/member/invoice/list", authoritiy: "tool.invoice.list"},
            { title: "代理店請求書作成", to: "/member/agency/invoice/new", authoritiy: "tool.agency.invoice.new"},
            { title: "代理店請求書一覧", to: "/member/agency/invoice/list", authoritiy: "tool.agency.invoice.list"},
            { title: "合算請求書作成", to: "/member/total/invoice/new", authoritiy: "tool.total.invoice.new"},
            { title: "合算請求書一覧", to: "/member/total/invoice/list", authoritiy: "tool.total.invoice.list"},
        ]},
        { title: "マスタ", icon: "mdi-database", items: [
            { title: "顧客マスタ", to: "/master/customer/list", authoritiy: "tool.master.customer.list"},
            { title: "顧客価格マスタ", to: "/master/customer_price/list", authoritiy: "tool.master.customer_price.list"},
            { title: "顧客価格マスタ複写", to: "/master/customer_price/copy", authoritiy: "tool.master.customer_price.copy"},
            { title: "検査分類マスタ", to: "/master/classification/list", authoritiy: "tool.master.classification.list"},
            { title: "検査項目マスタ", to: "/master/inspection/list", authoritiy: "tool.master.inspection.list"},
            { title: "報告書マスタ", to: "/master/report_type/list", authoritiy: "tool.master.report_type.list"},
            { title: "部門マスタ", to: "/master/department/list", authoritiy: "tool.master.department.list"},
            { title: "部署マスタ", to: "/master/section/list", authoritiy: "tool.master.section.list"},
            { title: "ユーザマスタ", to: "/master/user/list", authoritiy: "tool.master.user.list"},
            { title: "メール送信テスト", to: "/master/mail/test", authoritiy: "tool.master.mail.test"},
        ]},
        { title: "その他", icon: "mdi-cogs", items: [
            { title: "データ連携", to: "/member/export", authoritiy: "tool.export"},
        ]},
    ]

    /** メニューバー */
    private menuBarAllItems = [
        { title: "Home", icon: "mdi-home", to: "/", authoritiy: "logout"},
        { title: "Dash Board", icon: "mdi-view-dashboard", to: "/member/dashbord", authoritiy: "login"},
        { title: "Login", icon: "mdi-login", to: "/login", authoritiy: "logout"},
        { title: "Logout", icon: "mdi-logout", to: "/login", authoritiy: "login"},
    ]

    /** ナビゲーションメニュー */
    private naviAllItems = [
        { title: "Home", icon: "mdi-home", to: "/", authoritiy: "logout"},
        { title: "Dash Board", icon: "mdi-view-dashboard", to: "/member/dashbord", authoritiy: "login"},
        { title: "Login", icon: "mdi-login", to: "/login", authoritiy: "logout"},
        { title: "Logout", icon: "mdi-logout", to: "/login", authoritiy: "login"},
        { title: "Help", icon: "mdi-help", to: "/help", authoritiy: "everyone"},
    ]

    /**
     * 有効なメニューを取得
     */
    get menus() {
        const authorities = this.getUserAuthorities()
        return this.allMenus
            .filter(() => LoginStateModule.isLogin)
            .map(x => {
                    const menu = { ...x }
                    menu.items = x.items.filter(
                        i => authorities.includes(this.AUTH_ADMIN) ||
                        authorities.includes(i.authoritiy))
                    return menu
            })
            .filter(x => x.items.length > 0)
    }

    /**
     * 有効なメニューバーを取得
     */
    get menuBarItems() {
        return this.menuBarAllItems
            .filter(
                x => x.authoritiy === this.AUTH_EVERYONE || 
                    x.authoritiy === this.getAuthLogin())
    }

    /**
     * 有効なナビゲーションメニューを取得
     */
    get naviItems() {
        return this.naviAllItems
            .filter(
                x => x.authoritiy === this.AUTH_EVERYONE || 
                    x.authoritiy === this.getAuthLogin())
    }

    /**
     * ログイン状態による権限
     */
    private getAuthLogin() {
        return LoginStateModule.isLogin ? this.AUTH_LOGIN : this.AUTH_LOGOUT
    }

    /**
     * ログインユーザの権限
     */
    private getUserAuthorities(): string[] {
        const user = sessionStorage.getItem("loginUser")
        if (user === null) {
            return []
        }
        return (JSON.parse(user) as LoginUser).authorities
    }
}